<template>
  <v-btn color="secondary" @click="verifyPhone">Verify</v-btn>
</template>

<script>
  export default {
    name: "VerifyPhoneBtn",
    props: ["phoneNumber"],
    computed: {
      phone() {
        if (!this.$validator.isEmpty(this.phoneNumber)) {
          return this.phoneNumber;
        } else {
          return this.$route.params.code;
        }
      },
    },
    methods: {
      verifyPhone() {
        this.$store.commit("setLoadingStatus", true);

        this.$http
          .get(`/verify/phone/${this.phone}`)
          .then((response) => this.verifyPhoneSuccess(response))
          .catch(() => this.verifyPhoneFail());
      },

      verifyPhoneSuccess(response) {
        this.$store.commit("setLoadingStatus", false);

        this.$store.commit("setError", {
          message: "Thanks! Your phone number has been successfully verified!",
          type: "success",
        });
      },

      verifyPhoneFail() {
        this.$store.commit("setLoadingStatus", false);

        this.$store.commit("setError", {
          message: "Sorry, could not verify your phone number, please try again later.",
          type: "error",
        });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/VerifyPhone/VerifyPhoneBtn.vue